export enum RiskEnums{
  CURRENCY= "Currency",
  NUMERICID="NumericId"
}